var $ = require('jquery');

var $header = $('#header');
var $body = $('body');
var $delayTime = 10000;

$(window).on('load', function(){
    endLoading();
});

setTimeout('endLoading()', $delayTime);

function endLoading(){
    var $loadingAnim = $('#loading'),
        $body = $('body');
   
        $body.addClass('loaded');
    
        $loadingAnim.find('.loading__bg').on('transitionend', function( e ){ 
          $(this).parent().remove();
        });
}

// Nav Fixed
$(window).on('scroll', function() {
    if ($(window).scrollTop() > 100) {
        $header.addClass('is-fixed');
    } else {
        $header.removeClass('is-fixed');
    }
});

$(".secondary div").on("click", function() {
    $(this).next().slideToggle(200, 'linear');
    $(this).toggleClass('is-open');
});

$(".recruit__containerBlockAccTtl").on("click", function() {
    $(this).next().slideToggle();
    $(this).toggleClass('is-open');
    $(this).next().toggleClass('is-open');
});

// Nav Toggle Button
$('#toggle').on('click', function(){
    $header.toggleClass('is-open');
});

$('a[href^="#"]').on("click", function() {
    // スクロールの速度
    var speed = 400; // ミリ秒
    // アンカーの値取得
    var href= $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top - 150;
    // スムーススクロール
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
});

//マウスストーカー
$('html').on('mousemove', function(e){
    var $icon = $('#js-cursor');
    var $stoker = $('#js-stoker');
    $($icon).css({opacity: "1"});
    $($stoker).css({opacity: "1"});
    $($icon).css('transform', 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)');
    $($stoker).css('transform', 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)');
});

//メニューホバー時画像入れ替え
$('.header__innerNavMenuListBox, .secondary ul li').mouseover(function(e) {
    var imgClass = $(this).attr('data-nav');
	$('.img_' + imgClass).addClass('is-fire');
});

$('.header__innerNavMenuListBox, .secondary ul li').mouseout(function(e) {
    var imgClass = $(this).attr('data-nav');
	$('.img_' + imgClass).removeClass('is-fire');
});

$('a, button, input, select, textarea, #toggle, .secondary div, .swiper-button-next, .swiper-button-prev, .js-modal-btn, .recruit__containerBlockAccTtl').on('mouseenter', function(e) {
    $($body).addClass('is-change');
});

$('a, button, input, select, textarea, #toggle, .secondary div, .swiper-button-next, .swiper-button-prev, .js-modal-btn, .recruit__containerBlockAccTtl').on('mouseleave', function(e) {
    $($body).removeClass('is-change');
});

$('#movie-btn').on('click', function(){
    $($body).removeClass('is-change');
});

$('.modal-video, .modal-video-body, .modal-video-close-btn ').on('mouseenter', function(e) {
    $($body).addClass('is-none');
});

$('.modal-video, .modal-video-body, .modal-video-close-btn ').on('mouseleave', function(e) {
    $($body).removeClass('is-none');
});

$('.cat-name select').on('change', function(){

    var $this = $(this)
    var $option = $this.find('option:selected');
    $('.cat-label').text($option.text());
    // onchange後にフォーカスしてるのが嫌な場合
    $this.blur();
  
});

$('.year-name select').on('change', function(){

    var $this = $(this)
    var $option = $this.find('option:selected');
    $('.year-label').text($option.text());
    // onchange後にフォーカスしてるのが嫌な場合
    $this.blur();
  
});